import React, { ChangeEvent } from "react";
import { format } from "@/utils/date";

import { formatNumber } from "@/utils/number";
import { ServiceReserveStatus } from "@/apis/clients";
import CouponCodeField from "@/components/organisms/reservations/coupon/CouponCodeField";
import { JP_FULL_DATE_FORMAT } from "@/utils/const";

export interface ServiceMenuData {
  name?: string;
  description?: string;
  price?: number;
  options?: ServiceMenuOptionDetail[];
}

export interface ServiceMenuOptionDetail {
  name: string;
  description: string;
  price: number;
  time: number;
}
type Props = {
  menus: ServiceMenuData[];
  options: ServiceMenuOptionDetail[];
  type?: string;
  summaryPrice?: string;
  isFee?: boolean;
  serviceReserveStatus?: ServiceReserveStatus;
  isCouponVisible?: boolean;
  isCouponApplied?: boolean;
  couponCode?: string;
  subtotalPrice?: string;
  couponDiscountPrice?: string;
  couponLabel?: string;
  isCouponLoading?: boolean;
  couponErrorMessage?: string;
  onCouponChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onCouponApply?: () => void | Promise<void>;
  onCouponCancel?: () => void | Promise<void>;
};

type MenuProps = {
  name?: string;
  description?: string;
  price?: number;
  start?: Date;
  end?: Date;
  type?: string;
  amount?: number;
  showPrice?: boolean;
  quantity?: number;
};
const ItemMenu = ({
  name,
  price,
  start,
  end,
  type,
  amount,
  showPrice,
  quantity,
}: MenuProps) => {

  if (amount) {
    price = amount;
  }

  if (type === "event-seminar" && quantity && quantity > 1) {
    price = (amount ?? price ?? 0) * quantity;
  }

  return (
    <div className="border-b border-[#E9EBED] pb-4">
      <p className="text-[#757575]"> 選択中のサービスメニュー</p>
      <div className="flex justify-between mt-4">
        <p className="break-word">{name}</p>
        {showPrice && (
          <p className="shrink-0">{price ? `${formatNumber(price)}円` : ``}</p>
        )}
      </div>
      {type === "event-seminar" && (
        <div className="text-sm mt-2 font-normal flex justify-between">
          {`${start ? format(start, JP_FULL_DATE_FORMAT) : ""} 〜 ${end ? format(end, "HH:mm") : ""
            }`}
          {quantity != null && quantity > 0 && (
            <p>{`チケット数 `}{quantity}枚</p>
          )}
        </div>
      )}
    </div>
  );
};
const ItemOption = ({ name, price, amount }: MenuProps) => {
  if (amount) {
    price = amount;
  }
  return (
    <div className="border-b border-[#E9EBED] pb-4">
      <div className="flex justify-between mt-4">
        <p className="break-word">{name}</p>
        <p className="shrink-0">{price ? `${formatNumber(price)}円` : ``}</p>
      </div>
    </div>
  );
};
export default function ServiceMenu({
  isFee = true,
  menus,
  options,
  summaryPrice,
  type,
  serviceReserveStatus,
  isCouponVisible = false,
  isCouponApplied = false,
  couponCode = "",
  subtotalPrice,
  couponDiscountPrice,
  couponLabel,
  isCouponLoading = false,
  couponErrorMessage,
  onCouponChange,
  onCouponApply,
  onCouponCancel,
}: Props) {
  return (
    <div className="font-bold text-base bg-white">
      <div className="gap-y-4 flex flex-col">
        {menus?.map((data, index) => (
          <div key={index}>
            <ItemMenu
              {...data}
              type={type}
              showPrice={
                !(
                  serviceReserveStatus === ServiceReserveStatus.ALL && index > 0
                )
              }
            />
          </div>
        ))}
      </div>

      {options.length > 0 && <p className="text-[#757575] mt-4">オプション</p>}
      {options?.map((option, index) => {
        return (
          <div key={index}>
            <ItemOption {...option} />
          </div>
        );
      })}
      {isFee ? (
        <>
          {isCouponApplied && subtotalPrice && couponDiscountPrice ? (
            <div className="border-t border-[#E9EBED] pt-4 mb-4">
              <div className="flex items-center justify-between">
                <span>小計(税込)</span>
                <span>{subtotalPrice}</span>
              </div>
              <div className="flex items-center justify-between mt-4">
                <span>
                  クーポン内容
                  {couponLabel ? `（${couponLabel}）` : ""}
                </span>
                <span className="text-[#FF0000]">{couponDiscountPrice}</span>
              </div>
            </div>
          ) : null}
          <div className="text-right bg-gray-50 border-y border-gray-100 justify-end py-2 flex gap-x-6">
            <span className="text-gray-600">支払金額 (税込)</span>
            <span>{summaryPrice}</span>
          </div>
          {isCouponVisible && onCouponChange && onCouponApply && onCouponCancel ? (
            <CouponCodeField
              isApplied={isCouponApplied}
              code={couponCode}
              isLoading={isCouponLoading}
              errorMessage={couponErrorMessage}
              onChange={onCouponChange}
              onApply={onCouponApply}
              onCancel={onCouponCancel}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
